import lazyPages from "../lazy-loading";

// import BookingDetails from "../../pages/booking-details/Booking-details.jsx";
// import PaymentDetails from "../../pages/payment-details/Payment-details.jsx";

// const bookingRoutes = [
//   { path: "", element: <BookingDetails /> },
//   { path: "payment", element: <PaymentDetails /> },
// ];

const bookingRoutes = [
  { path: "", element: <lazyPages.bookingDetails /> },

  { path: "partner/confirm", element: <lazyPages.ConfirmBookingPartner /> },

  {
    path: "payment",

    children: [
      {
        path: "",
        element: <lazyPages.paymentDetails />,
      },
      {
        path: "processing",
        element: <lazyPages.paymentProcessing />,
      },
      {
        path: "success",
        element: <lazyPages.paymentSuccess />,
      },
      {
        path: "failure",
        element: <lazyPages.PaymentFailure />,
      },
      {
        path: "initialize/mobile",
        element: <lazyPages.PaymentInitializeMobile />,
      },
      {
        path: "processing/mobile",
        element: <lazyPages.PaymentProcessingMobile />,
      },
      {
        path: "failure/mobile",
        element: <lazyPages.PaymentFailureMobile />,
      }
    ],
  },
];

export default bookingRoutes;
